import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SolicitudesProcesosService from '../../services/SolicitudesProcesosService';
import './SolicitudesProcesosBadge.css';

const ADMIN_ROLES = ['admin', 'adminregional', 'adminarea'];

const isAdminUser = (user) => {
  const roleName = (user?.roleName || user?.role || '').toLowerCase().replace(/\s+/g, '');
  return ADMIN_ROLES.some((r) => roleName.includes(r));
};

const SolicitudesProcesosBadge = () => {
  const { user, isLoading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const intervalRef = useRef(null);

  const fetchCount = async () => {
    if (authLoading || !user) return;
    try {
      const response = await SolicitudesProcesosService.getCount();
      if (response?.ok) {
        setUnreadCount(response.unreadCount || 0);
      }
    } catch (error) {
      console.error('Error al cargar count de solicitudes:', error);
    }
  };

  useEffect(() => {
    if (authLoading || !user || !isAdminUser(user)) return;
    fetchCount();
    intervalRef.current = setInterval(fetchCount, 60000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [authLoading, user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!user || !isAdminUser(user)) return null;

  return (
    <button
      type="button"
      className="solicitudes-badge-btn"
      onClick={() => navigate('/admin/solicitudes-procesos')}
      title="Solicitudes a atender"
    >
      <i className="fas fa-clipboard-list"></i>
      <span>Solicitudes a atender</span>
      {unreadCount > 0 && (
        <span className="solicitudes-badge-count">{unreadCount}</span>
      )}
    </button>
  );
};

export default SolicitudesProcesosBadge;
